import React from 'react';

import { Box, CircularProgress } from '@mui/material';
import LogoDark from '../../assets/logo-flat-dark.svg';
import LogoLight from '../../assets/logo-flat-white.svg';
import { useSelector } from 'react-redux';

const LoadingDial = ({children}) => {
  const useLight = useSelector((state) => state.preferences.darkTheme);

  return (
    <Box
      sx={{
        position: 'relative',
        opacity: 0.5,
        color: 'lightgray',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        flexDirection:'column',
        gap:2
      }}
    >
      {/* <Box component="img" src={useLight ? LogoLight : LogoDark} width="42px" height="42px" position="absolute" /> */}
      <CircularProgress position="absolute" size={80} thickness={1} color="inherit" />
      {children}
    </Box>
  );
};

export default LoadingDial;
